var React = require('react');

function Dog (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#a)","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M11 5h2M19 12c-.667 5.333-2.333 8-5 8h-4c-2.667 0-4.333-2.667-5-8","key":0}),React.createElement("path",{"d":"M11 16c0 .667.333 1 1 1s1-.333 1-1h-2zM12 18v2M10 11v.01M14 11v.01M5 4l6 .97-6.238 6.688a1.02 1.02 0 0 1-1.41.111.953.953 0 0 1-.327-.954L5 4zM19 4l-6 .97 6.238 6.688c.358.408.989.458 1.41.111a.953.953 0 0 0 .327-.954L19 4z","key":1})]));
}

Dog.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Dog;

Dog.default = Dog;
